// import { types, mediaQueryStyles } from '@newsela/angelou';

// const { mediaQuery: mq } = mediaQueryStyles;
// const { sm, xs, md } = types.breakpoints.BreakpointNames;
// const { ui } = types.colors;

// const greyDark = ui.neutral[700];

export const widgetCss = {
  display: "flex",
  borderRadius: "16px",
  width: "100%",
  background: "#CCE1FF",
  padding: "12px 16px 16px 16px",
  minHeight: "49%",
  flexDirection: "column",
  alignItems: "center",
  "&:after, :focus, :focus-within": {
    cursor: "pointer",
    "-webkit-box-shadow": "none",
    "-moz-box-shadow": "none",
    "box-shadow": "none",
    transition: "none",
  },
  "& > :first-child": {
    background: "#CCE1FF",
    width: "100%",
    height: "100%",
    padding: "0px",
    display: "flex",
    flexDirection: "column",
    ".infoIcon": {
      width: "16px",
      height: "16px",
      position: "absolute",
      right: 8,
      top: 8,
    },
  },
  "& > :last-child": {
    "& > :last-child": {
      minHeight: "90%",
    },
  },
};

export const toolTipCss = {
  width: "16px",
  height: "16px",
  position: "absolute",
  right: 4,
  top: 2,
  ":hover, :focus, :focus-within": {
    background: "transparent",
  },
};
